import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '../../_common/functions'
import Text from '../../elements/Typo/Text'
import CommonInputText from '../commonInputText'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import Dropdown from '../../elements/Form/dropdown'
import Button from '../../elements/button'
import { IoCheckmarkOutline } from 'react-icons/io5'
import { RxCross2 } from 'react-icons/rx'
import { RiEditLine, RiDeleteBinLine } from 'react-icons/ri'
import Devider from '../../pages/CreateExperiment/designExperiment/_components/devider'
import { SuccessApiResponse } from '../../store/api/apiTypes'
import toast from 'react-hot-toast'
import { ExperimentDetailsI } from '../../_config/types'
import Label from '../../elements/formLabel'
import CustomDatePicker from '../CustomDatePicker'
import moment from 'moment'
import NumberInput from '../../elements/numberInput'
import { IScheduleRecurringFormInputs } from '../../_common/formProps'
import { useExperimentApi } from '../../store/api/hooks/experimentApiHook'
import { StylesConfig } from 'react-select'
import RecurringDataSelectionModal from '../../pages/MyExperiment/components/recurring/recurringDataSelection.modal'
import { createPortal } from 'react-dom'
import { useNavigate } from 'react-router-dom'
import { URLS } from '../../_config'
import Loader from '../loader'
import Icon from '../icons'

const twoDecimalRegex = /^\d+(\.\d{0,2})?$/

const DateOptions = Array.from({ length: 28 }, (_, i) => ({
    label: String(i + 1),
    value: i + 1,
}))
const RepeatOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
]

const customStyleOption: StylesConfig = { multiValueRemove: (base) => ({ display: 'none' }), multiValue: (base) => ({ ...base, borderRadius: '1.667rem', backgroundColor: '#F5E003' }), dropdownIndicator: (base, props) => ({ display: 'none' }) }
const dateToDBDate = (date: any) => {
    return moment(date).format('YYYY-MM-DD')
}
interface ScheduleExperimentModalProps {
    isEdit?: boolean
    isModalOpen: boolean
    onClose: (refetchExptDetails?: boolean) => void
    experiment: ExperimentDetailsI
}

interface SchedulePayloadI {
    start_date: string
    end_date: string
    schedule_frequency: string
    schedule_frequency_duration: number
    schedule_type: string
    schedule_sub_type: number
    schedule_type_value: number
    schedule_type_value_day_name: string
}
const ScheduleasRecurringMeasurementModal: React.FC<ScheduleExperimentModalProps> = ({ isEdit = false, isModalOpen, onClose, experiment }) => {
    const { t } = useTranslation()
    const localizedOrdinalOptions = [
        { label: t('First'), value: 1 },
        { label: t('Second'), value: 2 },
        { label: t('Third'), value: 3 },
        { label: t('Fourth'), value: 4 },
    ]
    const localizedDayOptions = [
        { label: t('Monday'), value: 'Monday', isDisabled: new Date().getDay() == 1 },
        { label: t('Tuesday'), value: 'Tuesday', isDisabled: new Date().getDay() == 2 },
        { label: t('Wednesday'), value: 'Wednesday', isDisabled: new Date().getDay() == 3 },
        { label: t('Thursday'), value: 'Thursday', isDisabled: new Date().getDay() == 4 },
        { label: t('Friday'), value: 'Friday', isDisabled: new Date().getDay() == 5 },
        { label: t('Saturday'), value: 'Saturday', isDisabled: new Date().getDay() == 6 },
        { label: t('Sunday'), value: 'Sunday', isDisabled: new Date().getDay() == 0 },
    ]
    const localizedMonthOptions = [
        { label: t('3 month'), value: 3 },
        { label: t('6 month'), value: 6 },
        { label: t('12 month'), value: 12 },
    ]
    const experimentApi: any = useExperimentApi()
    const { createRecurringExpt, getSchedulingDetesForRecurringExperiment } = useExperimentApi()
    const [dataSelection, setDataSelection] = useState<boolean>(false)
    const [setColumns] = useState<any>([])
    const [selectedTable, setSelectedTable] = useState<string>('')
    const [dataPreset, setDataPreset] = useState<boolean>(false)
    const [working, setWorking] = useState<boolean>(false)
    const [schedules, setSchedules] = useState<ExperimentDetailsI[]>([])
    const [editingIndex, setEditingIndex] = useState<number | null>(null)
    const [editDate, setEditDate] = useState<Date | null>(null)
    const navigate: any = useNavigate()

    const _handleCloseModal = (refetchExptDetails?: boolean) => {
        trackEvent('recurring_schedule_modal_closed', { experiment_literal: experiment?.experiment_literal })
        reset()
        if (refetchExptDetails) {
            onClose(refetchExptDetails)
        } else {
            onClose()
        }
    }

    const {
        register,
        handleSubmit,
        control,
        reset,
        watch,
        setValue,
        trigger,
        getValues,
        formState: { errors },
    } = useForm<IScheduleRecurringFormInputs>({
        mode: 'onChange',
        defaultValues: {
            name: '',
            hypothesis: '',
            use_case: { label: '', value: '' },
            metrices: [],
            schedule_tags: [],
            group_configs: [],

            measurementType: 0,
            date_range: [],
            repeat: RepeatOptions[0],
            repeatType: 'weekly',
            repeatOnType: 'date',
            repeatOnDay: null,
            repeatOnDate: null,
        },
        //resolver: yupResolver(ScheduleRecurringFormValidation),
    })

    const measurementType_watch = watch('measurementType')
    const repeatType_watch = watch('repeatType')
    const repeatOnType_Watch = watch('repeatOnType')
    const date_range_watch = watch('date_range')
    const repeat_watch = watch('repeat')
    const repeatOnDay_watch = watch('repeatOnDay')
    const repeatOnDate_watch = watch('repeatOnDate')
    const scheduleSub_watch = watch('schedule_sub')

    const isDateRangeLessThan30Days = () => {
        if (!date_range_watch?.length || !date_range_watch[0] || !date_range_watch[1]) {
            return true
        }
        if (date_range_watch?.length === 2) {
            const daysDiff = moment(date_range_watch[1]).diff(moment(date_range_watch[0]), 'days')
            return daysDiff < 30
        }
        return true
    }

    const isDateRangeLessThan6Days = () => {
        if (!date_range_watch?.length || !date_range_watch[0] || !date_range_watch[1]) {
            return true
        }
        if (date_range_watch?.length === 2) {
            const daysDiff = moment(date_range_watch[1]).diff(moment(date_range_watch[0]), 'days')
            return daysDiff < 6
        }
        return true
    }

    const getDynamicRepeatOptions = () => {
        if (!date_range_watch?.length || !date_range_watch[0] || !date_range_watch[1]) {
            return RepeatOptions
        }

        const daysDiff = moment(date_range_watch[1]).diff(moment(date_range_watch[0]), 'days') + 1

        if (repeatType_watch === 'weekly') {
            const maxRepeat = Math.floor(daysDiff / 7)
            const limitedRepeat = Math.min(maxRepeat, 4)
            return Array.from({ length: limitedRepeat }, (_, i) => ({
                label: String(i + 1),
                value: i + 1,
            }))
        } else if (repeatType_watch === 'monthly') {
            const maxRepeat = Math.floor(daysDiff / 30)
            const limitedRepeat = Math.min(maxRepeat, 3)
            return Array.from({ length: limitedRepeat }, (_, i) => ({
                label: String(i + 1),
                value: i + 1,
            }))
        }

        return RepeatOptions
    }

    const isDateRangeValid = () => {
        return date_range_watch?.length === 2 && date_range_watch[0] && date_range_watch[1] && repeatType_watch
    }

    const { fields: controlGroups, append: controlGroupsAppend, remove: controlGroupsRemove } = useFieldArray({ control, name: 'group_configs' })

    const setControlGroupValues = () => {
        controlGroupsRemove()
        experiment?.experiment_metadatas?.interventions?.[0]?.group_configs.map((group_configs: any) => {
            controlGroupsAppend({
                name: group_configs?.name ?? '',
                action: group_configs?.action ?? '',
                group_allocation_percentage: group_configs?.group_allocation_percentage ?? 0,
                group_size: group_configs?.group_size ?? 0,
                is_control: group_configs?.is_control ?? false,
            })
        })
    }

    const setFormValues = () => {
        const metrices = experiment?.experiment_metadatas?.metrices.map((metric: any) => ({ label: metric?.literral_value ?? '', value: metric?.kpi_type ?? '', ...metric })) ?? []
        setValue('name', experiment?.experiment_name ?? '')
        setValue('hypothesis', experiment?.hypothesis ?? '')
        setValue('use_case', { label: experiment?.use_case?.title ?? '', value: experiment?.use_case?.use_case_literal ?? '' })
        setValue('metrices', metrices)
        setControlGroupValues()
        //setValue('date_range', [moment(experiment?.start_date).toDate(), moment(experiment?.end_date).toDate()])
        setDataPreset(true)
    }

    const getDateRange = (data: IScheduleRecurringFormInputs) => {
        if (data.date_range.length > 1) {
            return [moment(data.date_range[0]).format('YYYY-MM-DD'), moment(data.date_range[1]).format('YYYY-MM-DD')]
        } else {
            return [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        }
    }

    const validateField = (value: any) => {
        return true
    }

    // dims for recurring-vs-total experiment dashboards, shared by both creation paths
    const buildRecurringCreateSuccessProps = (data: any) => ({
        experiment_literal: experiment?.experiment_literal,
        use_case_literal: experiment?.use_case?.use_case_literal,
        repeat_type: data?.repeatType,
        schedule_count: schedules.length,
    })

    const getColumns = () => {
        experimentApi.getColumnsForGroupDristribution(
            { literal: experiment?.experiment_literal, tableType: 'Design' },
            (resp: any) => {
                setColumns(
                    resp.data.datetime_columns.map((colName: string) => ({
                        label: colName,
                        value: colName,
                    })),
                )
            },
            (error: any) => {
                //----------
            },
        )
    }

    const getRecurringCongigData = (data: any) => {
        const selectedDuration = localizedMonthOptions.find((option) => option.value === data?.duration?.value)
        const durationInMonths = selectedDuration?.value ?? data?.duration?.value
        const dateRange = durationInMonths ? [moment().format('YYYY-MM-DD'), moment().add(durationInMonths, 'M').format('YYYY-MM-DD')] : getDateRange(data)
        const schedule_type = data.repeatType == 'weekly' ? 'day' : data.repeatOnType
        const measurement_change_config: any = {
            start_date: dateRange[0],
            end_date: dateRange[1],
            schedule_frequency: data.repeatType,
            schedule_frequency_duration: data.repeat.value,
            schedule_type,
            schedule_sub_type: data.repeatType == 'monthly' && data.repeatOnType == 'day' ? data.schedule_sub?.value : 0,
            schedule_type_value: data.repeatType == 'monthly' ? data.repeatOnDate?.value || null : null,
            schedule_type_value_day_name: schedule_type == 'day' ? data.repeatOnDay?.value : null,
        }

        return {
            measurement_type: measurementType_watch == 1 ? 'manual' : 'auto',
            recurring_type: 'individual',
            measurement_change_config,
            users_schedule_at: [...schedules].sort((a: any, b: any) => new Date(a).getTime() - new Date(b).getTime()),
        }
    }

    const [filePayload, setFilePayload] = useState<any>(null)

    const createRecurringExperiment = (payload: any) => {
        setFilePayload(payload)
        setDataSelection(false)
        trigger()
            .then((valid: boolean) => {
                if (valid) {
                    const params: any = getRecurringCongigData(getValues())
                    const _payload: any = { ...params, ...payload }
                    const { is_draft, step, literal, delta_measurement_table_name, ...restPayload } = _payload
                    const finalPayload: any = { ...restPayload }

                    if (measurementType_watch == 1) {
                        finalPayload.user_created_measurement_table_name = delta_measurement_table_name
                    } else {
                        finalPayload.delta_measurement_table_name = delta_measurement_table_name
                    }

                    setWorking(true)
                    createRecurringExpt(
                        { literal, params: finalPayload },
                        (resp: SuccessApiResponse<any>) => {
                            trackEvent('recurring_schedule_create_success', buildRecurringCreateSuccessProps(getValues()))
                            _handleCloseModal(true)
                            navigate(URLS.MY_EXPERIMENTS)
                            setWorking(false)
                        },
                        (error: any) => {
                            trackEvent('recurring_schedule_create_failed', { experiment_literal: experiment?.experiment_literal })
                            setWorking(false)
                            toast.error(error?.response?.data?.message)
                        },
                    )
                }
            })
            .catch((error) => {
                console.error('Error :', error)
            })
    }

    const onSubmit = (data: IScheduleRecurringFormInputs) => {
        if (schedules?.length === 0) {
            toast.error(t('Your configuration does not create any schedule. Please adjust your recurring configuration to create at least one schedule.'))
            return false
        }

        trackEvent('recurring_schedule_submitted', { experiment_literal: experiment?.experiment_literal, schedule_count: schedules.length })

        if (filePayload) {
            createRecurringExperiment(filePayload)
        } else {
            setWorking(true)
            const params: any = getRecurringCongigData(data)
            createRecurringExpt(
                { literal: experiment.experiment_literal, params },
                (resp: SuccessApiResponse<any>) => {
                    trackEvent('recurring_schedule_create_success', buildRecurringCreateSuccessProps(data))
                    _handleCloseModal(true)
                    navigate(URLS.MY_EXPERIMENTS)
                    setWorking(false)
                },
                (error: any) => {
                    trackEvent('recurring_schedule_create_failed', { experiment_literal: experiment?.experiment_literal })
                    console.log(error)
                    toast.error(error?.message)
                    setWorking(false)
                },
            )
        }
    }

    const [schedulePayload, setSchedulePayload] = useState<SchedulePayloadI>({
        start_date: '2026-04-09T06:46:53.219Z',
        end_date: '2026-04-09T06:46:53.219Z',
        schedule_frequency: 'string',
        schedule_frequency_duration: 0,
        schedule_type: 'string',
        schedule_sub_type: 0,
        schedule_type_value: 0,
        schedule_type_value_day_name: 'string',
    })

    const fetchSchedules = () => {
        if (!experiment?.experiment_literal) return
        getSchedulingDetesForRecurringExperiment(
            {
                literal: experiment.experiment_literal,
                ...schedulePayload,
            },
            (resp: any) => {
                const data = resp.data ?? []
                setSchedules(data)
                trackEvent('recurring_schedule_preview_fetched', { experiment_literal: experiment?.experiment_literal, schedule_count: data.length })
            },
            (error: any) => {
                trackEvent('recurring_schedule_preview_failed', { experiment_literal: experiment?.experiment_literal })
                toast.error(error.message)
                setSchedules([])
            },
        )
    }

    useEffect(() => {
        const scheduleType = repeatType_watch === 'weekly' ? 'day' : repeatOnType_Watch
        setSchedulePayload({
            start_date: date_range_watch?.[0] ? moment(date_range_watch[0]).format('YYYY-MM-DD') : '',
            end_date: date_range_watch?.[1] ? moment(date_range_watch[1]).format('YYYY-MM-DD') : '',
            schedule_frequency: repeatType_watch ?? '',
            schedule_frequency_duration: Number(repeat_watch?.value ?? 0),
            schedule_type: scheduleType ?? '',
            schedule_sub_type: repeatType_watch === 'monthly' && repeatOnType_Watch === 'day' ? Number(scheduleSub_watch?.value ?? 0) : 0,
            schedule_type_value: repeatType_watch === 'monthly' ? Number(repeatOnDate_watch?.value ?? 0) : 0,
            schedule_type_value_day_name: scheduleType === 'day' ? String(repeatOnDay_watch?.value ?? '') : '',
        })
    }, [date_range_watch, repeat_watch, repeatType_watch, repeatOnType_Watch, repeatOnDay_watch, repeatOnDate_watch, scheduleSub_watch])

    useEffect(() => {
        const isValid =
            schedulePayload.start_date &&
            schedulePayload.end_date &&
            schedulePayload.schedule_frequency &&
            schedulePayload.schedule_frequency_duration > 0 &&
            schedulePayload.schedule_type &&
            (schedulePayload.schedule_type_value_day_name || schedulePayload.schedule_type_value > 0 || schedulePayload.schedule_sub_type > 0)

        if (isValid) {
            fetchSchedules()
        }
    }, [schedulePayload])

    useEffect(() => {
        if (experiment && isModalOpen) {
            trackEvent('recurring_schedule_modal_opened', { experiment_literal: experiment?.experiment_literal })
            setFormValues()
        }
        if (experiment && !experiment.is_measurement_flow) {
            getColumns()
        }
    }, [experiment, isModalOpen])

    const prevRepeatType = useRef<string | undefined>(undefined)
    const prevRepeatOnType = useRef<string | undefined>(undefined)
    const prevMeasurementType = useRef<number | undefined>(undefined)

    useEffect(() => {
        if (prevRepeatType.current !== undefined && prevRepeatType.current !== repeatType_watch) {
            trackEvent('recurring_schedule_repeat_type_changed', { experiment_literal: experiment?.experiment_literal, repeat_type: repeatType_watch })
        }
        prevRepeatType.current = repeatType_watch
    }, [repeatType_watch])

    useEffect(() => {
        if (prevRepeatOnType.current !== undefined && prevRepeatOnType.current !== repeatOnType_Watch) {
            trackEvent('recurring_schedule_repeat_on_type_changed', { experiment_literal: experiment?.experiment_literal, repeat_on_type: repeatOnType_Watch })
        }
        prevRepeatOnType.current = repeatOnType_Watch
    }, [repeatOnType_Watch])

    useEffect(() => {
        if (prevMeasurementType.current !== undefined && prevMeasurementType.current !== measurementType_watch) {
            trackEvent('recurring_schedule_measurement_type_changed', { experiment_literal: experiment?.experiment_literal, measurement_type: measurementType_watch == 1 ? 'manual' : 'auto' })
        }
        prevMeasurementType.current = measurementType_watch
    }, [measurementType_watch])

    const handleConfirmEdit = (i: number) => {
        if (editDate) {
            const newDate = moment(editDate).format('YYYY-MM-DDT00:00:00')
            trackEvent('recurring_schedule_date_edited', { experiment_literal: experiment?.experiment_literal, schedule_index: i, new_date: newDate })
            setSchedules((prev) => prev.map((s, index) => (index === i ? (newDate as any) : s)))
        }
        setEditingIndex(null)
        setEditDate(null)
    }

    const handleCancelEdit = () => {
        setEditingIndex(null)
        setEditDate(null)
    }

    const handleStartEdit = (i: number, schedule: any) => {
        setEditingIndex(i)
        setEditDate(schedule ? new Date(schedule) : null)
    }

    const handleDeleteSchedule = (i: number) => {
        const remaining = schedules.length - 1
        trackEvent('recurring_schedule_row_deleted', { experiment_literal: experiment?.experiment_literal, remaining_count: remaining })
        setSchedules((prev) => prev.filter((_, index) => index !== i))
    }

    useEffect(() => {
        setSelectedTable(experiment?.data_mappings?.user_created_measurement_table_name || experiment?.data_mappings?.delta_measurement_table_name)
    }, [measurementType_watch])

    return (
        <dialog className={`modal ${isModalOpen ? 'modal-open' : ''}`}>
            <div className="modal-box remove-scroll border-0 p-0 pb-4 rounded-[0.833rem] w-xl max-w-3xl flex flex-col overscroll-behavior-y-none relative ">
                <div className="mr-2 mt-2 text-end">
                    <button className="btn btn-sm btn-circle btn-ghost" disabled={working} type="button" onClick={() => _handleCloseModal()}>
                        ✕
                    </button>
                </div>

                <div className="flex flex-col justify-center items-center sticky bg-white z-[100] py-3">
                    <Text className="!text-[1.333rem] font-bold">{t('Recurring Experiment Configuration')}</Text>
                </div>
                <div className="mt-3 px-10 py-2">
                    <Devider label={t('Experiment Details')} />
                    <form onSubmit={handleSubmit(onSubmit)} className="pt-2">
                        <div className="grid grid-cols-2 gap-4 my-4">
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: t('Enter Name'), minLength: 8 }}
                                render={({ field: { onChange, value } }) => (
                                    <CommonInputText disabled value={value} onChange={onChange} label={t('Experiment Name')} required={true} placeholder={t('Exp 1')} error={errors?.name?.message ?? errors?.name?.type} data-testid="name" />
                                )}
                            />
                            <Controller
                                name="hypothesis"
                                control={control}
                                rules={{ required: t('Enter Hypothesis') }}
                                render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                    <CommonInputText
                                        disabled
                                        label={t('Hypothesis')}
                                        value={value}
                                        onChange={onChange}
                                        required={true}
                                        showValueInTooltip={true}
                                        placeholder={t('1:1 Promo for D2C Customers will increase Revenue by 5%')}
                                        error={errors?.hypothesis?.message}
                                        data-testid="hypothesis"
                                    />
                                )}
                            />
                            <Controller
                                name="use_case"
                                control={control}
                                rules={{ required: t('Please Select Usecase') }}
                                render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                    <Dropdown label={t('Use Case')} disabled required={true} placeholder={t('Algo Tasking')} value={value} onChange={onChange} error={errors.use_case?.message as any} data-testid="usecase" />
                                )}
                            />
                            <Controller
                                name="metrices"
                                control={control}
                                rules={{ required: t('Please Select KPI(s) of Interest') }}
                                render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                    <Dropdown
                                        label={t('KPI(s) of Interest')}
                                        isMulti={true}
                                        disabled
                                        required={true}
                                        isClearable={false}
                                        customStyleOption={customStyleOption}
                                        placeholder={t('Net Revenue')}
                                        value={value}
                                        data-testid="interest"
                                        onChange={onChange}
                                        error={errors.metrices?.message as any}
                                    />
                                )}
                            />
                        </div>

                        <Devider label={t('Group Distribution')} />

                        <div className="my-4">
                            <p className="text-[0.6rem] font-medium">{t('% split for each group')}</p>
                            <div className="flex items-center mb-4">
                                <div className="bg-white rounded-md w-3/4">
                                    <div className="grid grid-cols-3 gap-2">
                                        <div className="col-span-2 p-2 flex items-center gap-2">
                                            <span className=" text-center text-[0.583rem] font-normal italic w-2/5 ">{t('Group Name')}</span>
                                            <span className=" text-center text-[0.583rem] font-normal italic w-3/5">{t('Action Taken')}</span>
                                        </div>

                                        <div className="col-span-1 p-2 flex items-center">
                                            <span className=" text-center text-[0.583rem] font-normal italic w-full">{t('Distribution%')}</span>
                                        </div>
                                    </div>

                                    <div className="flex flex-col gap-2">
                                        {controlGroups.map((group: any, index: number) => (
                                            <div className="grid grid-cols-3 gap-2" key={`group_${index.toString()}`}>
                                                <div className="col-span-2 bg-[#f2f2f2] border border-gray-400 rounded-lg flex p-1 gap-1">
                                                    <div className="w-25">
                                                        <Controller
                                                            name={`group_configs.${index}.name` as 'group_configs.0.name'}
                                                            control={control}
                                                            rules={{ required: t('Please Enter Group Name') }}
                                                            render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                                                <CommonInputText value={value} onChange={onChange} placeholder={t('Ex: CO_2501_Tasking_BDR_Performance')} disabled error={errors?.group_configs?.[index]?.name?.message} />
                                                            )}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <Controller
                                                            name={`group_configs.${index}.action` as 'group_configs.0.action'}
                                                            control={control}
                                                            rules={{ required: t('Please Enter Action Taken') }}
                                                            render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                                                <CommonInputText
                                                                    multiline={true}
                                                                    value={value}
                                                                    onChange={onChange}
                                                                    placeholder={t('Ex: CO_2501_Tasking_BDR_Performance')}
                                                                    disabled
                                                                    error={errors?.group_configs?.[index]?.action?.message}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-span-1 bg-[#f2f2f2] border border-gray-400 rounded-lg flex p-1 gap-1">
                                                    <Controller
                                                        name={`group_configs.${index}.group_allocation_percentage` as 'group_configs.0.group_allocation_percentage'}
                                                        control={control}
                                                        rules={{
                                                            required: t('Please Enter Distribution %'),
                                                            validate: validateField,
                                                        }}
                                                        render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                                            <NumberInput
                                                                value={Number(Number(value).toFixed(2))}
                                                                onChange={(value: any) => {
                                                                    if (twoDecimalRegex.test(value)) {
                                                                        onChange(value)
                                                                        void trigger('group_configs')
                                                                    }
                                                                }}
                                                                disabled
                                                                allowDecimal
                                                                placeholder={t('Enter Distribution %')}
                                                                min={0}
                                                                max={100}
                                                                error={errors.group_configs?.[index]?.group_allocation_percentage?.message}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                        {errors.group_configs?.root?.message && <p className="text-error text-[.58rem]">{errors.group_configs?.root?.message}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Devider label={t('Measurement Change Configurations')} />

                        <div className="my-3">
                            <div className="grid grid-cols-4 gap-2">
                                <Label
                                    text={t('Measurement Type')}
                                    required
                                    information={t('Please select how do you want to add the data. "Manual" means you will upload the measurement data through CSV file and "Automatic" means you have the data already populating in a table')}
                                    className="!h-full !m-0"
                                />

                                <div className="col-span-3 flex items-center gap-3">
                                    <label className="flex items-center gap-2 text-[0.5rem]">
                                        <input type="radio" value={1} checked={measurementType_watch == '1'} {...register('measurementType')} className="accent-slate-700 w-[1rem]" />
                                        <Text size="sm">{t('Manual')}</Text>
                                    </label>
                                    <label className="flex items-center gap-2 text-[0.5rem]">
                                        <input type="radio" value={0} checked={measurementType_watch == '0'} {...register('measurementType')} className="accent-slate-700 w-[1rem]" />
                                        <Text size="sm">{t('Automatic')}</Text>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-2 items-stretch bg-primary p-[0.417rem] rounded-[0.417rem]">
                            <div>
                                <Label text={t('Select Recurrence Date Range.')} required={true} information={t('Choose how long this recurring measurement should run. Make sure your dates fall within your active measurement window.')} />

                                <Controller
                                    name={'date_range'}
                                    control={control}
                                    rules={{
                                        validate: {
                                            required: (value: any) => {
                                                return value?.[0] && value?.[1] ? true : t('Please select Recurring Period')
                                            },
                                            range: (value: any) => {
                                                if (value?.[0] && value?.[1]) {
                                                    const daysDiff = moment(value[1]).diff(moment(value[0]), 'days')
                                                    return daysDiff > 6 ? true : t('Date range should be more than 6 days')
                                                }
                                                return true
                                            },
                                        },
                                    }}
                                    render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                        <>
                                            {dataPreset && (
                                                <CustomDatePicker size="sm" value={value} minDate={moment(experiment?.end_date).add(1, 'day').startOf('day').toDate()} type={'range'} onChange={onChange} error={errors?.date_range?.message as any} />
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                            <div className="w-0 border-r border-white"></div>
                            <div>
                                <Label text={t('Repeat Every')} required={true} information={t('Choose to set if your recurring measurement will be weekly or monthly.')} />

                                <div className="flex gap-2">
                                    <Controller
                                        name="repeat"
                                        control={control}
                                        render={({ field: { onChange, onBlur, value, ref, name } }) => <Dropdown placeholder={t('Select any')} value={value} onChange={onChange} options={getDynamicRepeatOptions()} menuPlacement="top" />}
                                    />

                                    <label className="flex items-center gap-2 text-[0.5rem]">
                                        <input type="radio" value={'weekly'} disabled={isDateRangeLessThan6Days()} checked={repeatType_watch == 'weekly'} {...register('repeatType')} className="accent-slate-700 w-[1rem] disabled:accent-slate-200" />
                                        <Text size="sm">{t('Week')}</Text>
                                    </label>
                                    <label className="flex items-center gap-2 text-[0.5rem]">
                                        <input
                                            type="radio"
                                            value={'monthly'}
                                            disabled={isDateRangeLessThan30Days()}
                                            checked={repeatType_watch == 'monthly'}
                                            {...register('repeatType')}
                                            className="accent-slate-700 w-[1rem] disabled:accent-slate-200"
                                        />
                                        <Text size="sm">{t('Month')}</Text>
                                    </label>
                                </div>
                            </div>
                            <div className="w-0 border-r border-white"></div>
                            <div>
                                <Label text={t('Select Days')} required={true} information={t('Select a run date for automated measurements. For manual uploads, the date is determined based on the data you provide.')} />

                                {repeatType_watch == 'weekly' ? (
                                    <div className="w-28">
                                        <Controller
                                            name="repeatOnDay"
                                            control={control}
                                            rules={{ required: t('Day required') }}
                                            render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                                <Dropdown
                                                    disabled={!isDateRangeValid()}
                                                    placeholder={t('Select any')}
                                                    value={value}
                                                    defaultValue={localizedDayOptions[0]}
                                                    onChange={onChange}
                                                    options={localizedDayOptions}
                                                    menuPlacement={'top'}
                                                    error={errors.repeatOnDay?.message as any}
                                                />
                                            )}
                                        />
                                    </div>
                                ) : (
                                    <div className="flex flex-col gap-2">
                                        <div className="flex items-center gap-2 text-[0.5rem]">
                                            <label className="flex items-center gap-2 text-[0.5rem]">
                                                <input type="radio" value={'date'} disabled={!isDateRangeValid()} checked={repeatOnType_Watch == 'date'} {...register('repeatOnType')} className="accent-slate-700 w-[1rem]" />
                                                <Text size="sm">{t('On date')}</Text>
                                            </label>
                                            <label className="flex items-center gap-2 text-[0.5rem]">
                                                <input type="radio" value={'day'} disabled={!isDateRangeValid()} checked={repeatOnType_Watch == 'day'} {...register('repeatOnType')} className="accent-slate-700 w-[1rem]" />
                                                <Text size="sm">{t('On')}</Text>
                                            </label>
                                        </div>
                                        <div className="flex items-center gap-2 text-[0.5rem]">
                                            <div className={`w-40 ${repeatOnType_Watch == 'date' ? '' : 'hidden'}`}>
                                                <Controller
                                                    name="repeatOnDate"
                                                    control={control}
                                                    rules={{ required: repeatOnType_Watch == 'date' ? t('Day required') : false }}
                                                    render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                                        <Dropdown
                                                            placeholder={t('Select any')}
                                                            disabled={!isDateRangeValid() || repeatOnType_Watch != 'date'}
                                                            value={value}
                                                            defaultValue={DateOptions[0]}
                                                            onChange={onChange}
                                                            options={DateOptions}
                                                            menuPlacement={'top'}
                                                            error={errors.repeatOnDate?.message as any}
                                                        />
                                                    )}
                                                />
                                            </div>

                                            <div className={`flex gap-2 ${repeatOnType_Watch == 'day' ? '' : 'hidden'}`}>
                                                <div className="w-32">
                                                    <Controller
                                                        name="schedule_sub"
                                                        control={control}
                                                        rules={{ required: repeatOnType_Watch == 'day' ? t('required') : false }}
                                                        render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                                            <Dropdown
                                                                disabled={!isDateRangeValid() || repeatOnType_Watch != 'day'}
                                                                placeholder={t('Select any')}
                                                                value={value}
                                                                onChange={onChange}
                                                                options={localizedOrdinalOptions}
                                                                menuPlacement="top"
                                                                error={errors.schedule_sub?.message as any}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                <div className="w-32">
                                                    <Controller
                                                        name="repeatOnDay"
                                                        control={control}
                                                        rules={{ required: repeatOnType_Watch == 'day' ? t('Day required') : false }}
                                                        render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                                            <Dropdown
                                                                disabled={!isDateRangeValid() || repeatOnType_Watch != 'day'}
                                                                placeholder={t('Select any')}
                                                                value={value}
                                                                defaultValue={localizedDayOptions[0]}
                                                                onChange={onChange}
                                                                options={localizedDayOptions}
                                                                menuPlacement={'top'}
                                                                error={errors.repeatOnDay?.message as any}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {measurementType_watch != 1 && (
                            <div className="border border-slate-200 rounded-md flex items-center gap-2 mt-3 px-3 py-2">
                                <p className="font-bold text-[0.667rem]">{t('Your previous measurement data:')}</p>
                                <p className="text-[0.667rem] text-gray-500 flex-grow">{selectedTable}</p>
                                <Button
                                    size="sm"
                                    theme="secondary"
                                    className="!px-4 !py-1 !leading-none"
                                    onClick={() => {
                                        trackEvent('recurring_schedule_data_selection_opened', { experiment_literal: experiment?.experiment_literal })
                                        setDataSelection(true)
                                    }}
                                >
                                    {measurementType_watch == 1 ? t('Select Data') : t('Edit')}
                                </Button>
                            </div>
                        )}

                        <p className="text-gray-500 text-[0.5rem] mt-3 text-center leading-3">
                            {t('If your measurement data is already onboarded into BrewDat,')}
                            <br /> {t('Select it to enable automated measurement.')}
                        </p>

                        {schedules.length > 0 && (
                            <div className="mt-4">
                                <Devider label={t('Schedules')} />

                                <button type="button" onClick={fetchSchedules} className="rounded-md border border-gray-200 px-2 py-1 text-gray-500 hover:bg-gray-100">
                                    <Icon name="reset" />
                                </button>

                                <div className="mt-2 border border-gray-200 rounded-lg overflow-hidden">
                                    <div className="grid grid-cols-[1fr_1fr_auto] bg-gray-50 border-b border-gray-200">
                                        <div className="px-4 py-2 text-center">
                                            <Text size="sm" className="font-semibold text-gray-600">
                                                {t('Experiment Name')}
                                            </Text>
                                        </div>
                                        <div className="px-4 py-2 text-center">
                                            <Text size="sm" className="font-semibold text-gray-600">
                                                {t('Date')}
                                            </Text>
                                        </div>
                                        <div className="px-4 py-2 text-center">
                                            <Text size="sm" className="font-semibold text-gray-600">
                                                {t('Action')}
                                            </Text>
                                        </div>
                                    </div>
                                    <div className="max-h-[12rem] overflow-auto">
                                        {schedules.map((schedule: any, i: number) => (
                                            <div key={schedule.experiment_literal} className="grid grid-cols-[1fr_1fr_auto] border-b border-gray-100 last:border-b-0 items-center">
                                                <div className="px-4 py-3 text-center">
                                                    <Text size="sm" className="font-medium truncate" title={schedule.experiment_name}>
                                                        {experiment.experiment_name} - child({i + 1})
                                                    </Text>
                                                </div>
                                                <div className="px-4 py-3 text-center">
                                                    {editingIndex === i ? (
                                                        <CustomDatePicker
                                                            size="sm"
                                                            showClearIcon={false}
                                                            value={editDate}
                                                            minDate={moment(schedulePayload.start_date).add(1, 'day').toDate()}
                                                            maxDate={moment(schedulePayload.end_date).toDate()}
                                                            onChange={(date) => setEditDate(date as Date)}
                                                        />
                                                    ) : (
                                                        <Text size="sm" className="text-gray-600">
                                                            {schedule ? moment(schedule).format('DD MMM,YYYY') : ''}
                                                        </Text>
                                                    )}
                                                </div>
                                                <div className="px-4 py-3 flex items-center gap-2">
                                                    {editingIndex === i ? (
                                                        <>
                                                            <button type="button" className="w-7 h-7 rounded-md border border-gray-200 flex items-center justify-center text-green-500 hover:bg-green-50" onClick={() => handleConfirmEdit(i)}>
                                                                <IoCheckmarkOutline size={14} />
                                                            </button>
                                                            <button type="button" className="w-7 h-7 rounded-md border border-gray-200 flex items-center justify-center text-red-500 hover:bg-red-50" onClick={handleCancelEdit}>
                                                                <RxCross2 size={14} />
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button type="button" className="w-7 h-7 rounded-md border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-100" onClick={() => handleStartEdit(i, schedule)}>
                                                                <RiEditLine size={14} />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="w-7 h-7 rounded-md border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-red-50 hover:text-red-500"
                                                                onClick={() => handleDeleteSchedule(i)}
                                                            >
                                                                <RiDeleteBinLine size={14} />
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="mt-8 flex items-center justify-center gap-3 ">
                            <Button type="button" theme="tertiary" size="xs" disabled={working} onClick={() => _handleCloseModal()}>
                                <RxCross2 className="text-[1rem]" />
                                {t('No, Cancel')}
                            </Button>
                            <Button type="submit" theme="secondary" size="xs" className="text-white" disabled={working}>
                                {working ? (
                                    <Loader />
                                ) : (
                                    <>
                                        <IoCheckmarkOutline className="text-[1rem]" />
                                        {t('Yes Confirm')}
                                    </>
                                )}
                            </Button>
                        </div>
                        <div className="flex items-center gap-3"></div>
                    </form>
                </div>
            </div>

            {dataSelection &&
                createPortal(
                    <RecurringDataSelectionModal
                        createRecurringExperiment={createRecurringExperiment}
                        mode={'create'}
                        type={measurementType_watch == 1 ? 'manual' : 'auto'}
                        onClose={(reload: boolean) => setDataSelection(false)}
                        experiment={experiment}
                    />,
                    document.body,
                )}

            <div className="modal-backdrop pointer-events-none"></div>
        </dialog>
    )
}
export default ScheduleasRecurringMeasurementModal
